// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Grid,
} from '@material-ui/core';

/* -----------------Types--------------- */
import type {
  TempTag,
} from '../create/types';

/* -----------------Child components--------------- */
import Tag from './Tag';

/* -----------------Props--------------- */
type Props = {
  tags: TempTag[],

};

/* -----------------Component--------------- */
const ListTags = (props: Props) => {
  const {
    tags = [],
  } = props;
  return (
    <Grid
      container
      spacing={1}
      direction="row"
      justifyContent="flex-start"
    >
      {tags.map(({ label, type }) => (
        <Tag
          key={label}
          label={label}
          type={type}
        />
      ))}
    </Grid>
  );
};

export default ListTags;
